import { Component, DestroyRef, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ModalComponent } from '@shared/modal/modal.component';
import { BreadcrumbsComponent } from '@shared/breadcrumbs/breadcrumbs.component';
import { IpInfoService } from '@shared/ip-info/ip-info.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { isPlatformServer } from '@angular/common';

@Component({
    selector: 'companyid-root',
    imports: [RouterOutlet, HeaderComponent, FooterComponent, ModalComponent, BreadcrumbsComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
    private readonly ipInfoService = inject(IpInfoService);
    private readonly destroyRef = inject(DestroyRef);
    private readonly platformId = inject<string>(PLATFORM_ID);
    public ngOnInit(): void {
        if (isPlatformServer(this.platformId)) {
            return;
        }
        this.ipInfoService.getIpInfo.pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
    }
}
